"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DuplexImageBlock = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _Typography = require("../Typography");
var _Container = require("../Container");
var _Button = require("../Button");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["as", "preHeading", "heading", "description", "buttonPrimary", "buttonSecondary", "image", "backgroundColor", "reverse", "slots", "slotProps", "className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className"],
  _excluded9 = ["className"],
  _excluded10 = ["className"],
  _excluded11 = ["className"],
  _excluded12 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classesRoot = (0, _classVarianceAuthority.cva)([], {
  variants: {
    backgroundColor: {
      none: [],
      light: ['bg-gray-50']
    }
  }
});
var classesContainer = (0, _classVarianceAuthority.cva)(['flex items-center justify-between gap-5 md:gap-8 xl:gap-15 2xl:gap-20'], {
  variants: {
    reverse: {
      "true": ['flex-col', 'lg:flex-row-reverse'],
      "false": ['flex-col lg:flex-row']
    }
  }
});

/**
 * Duplex Image Block - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/blocks-dupleximageblock) | [DSM](https://sharphealthcare.notion.site/Duplex-image-4c9a4315ce7d455693120c4e572df7d9)
 *
 * @example
 *
 * <DuplexImageBlock
 *   heading="Get care now"
 *   description="We have many care options..."
 *   image={{ src: 'image.jpg' }}
 *   buttonPrimary={{ label: 'Schedule now' }}
 *   reverse
 * />
 */
var DuplexImageBlock = exports.DuplexImageBlock = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _slots$container, _slotProps$container, _slots$contentContain, _slotProps$contentCon, _slots$preHeading, _slotProps$preHeading, _slots$heading, _slotProps$heading, _slots$description, _slotProps$descriptio, _slots$buttonContaine, _slotProps$buttonCont, _ref7, _slots$buttonPrimary, _ref8, _slots$buttonSecondar, _slots$buttonPrimary2, _slotProps$buttonPrim, _slots$buttonSecondar2, _slotProps$buttonSeco, _slots$buttonPrimaryC, _slots$buttonSecondar3, _slots$imageContainer, _slotProps$imageConta, _slots$image, _slotProps$image, _slotProps$preHeading2, _slotProps$descriptio2;
  var as = props.as,
    preHeading = props.preHeading,
    heading = props.heading,
    description = props.description,
    buttonPrimary = props.buttonPrimary,
    buttonSecondary = props.buttonSecondary,
    _props$image = props.image,
    image = _props$image === void 0 ? {} : _props$image,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? 'none' : _props$backgroundColo,
    _props$reverse = props.reverse,
    reverse = _props$reverse === void 0 ? false : _props$reverse,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var Container = (_slots$container = slots.container) !== null && _slots$container !== void 0 ? _slots$container : _Container.Container;
  var _ref = (_slotProps$container = slotProps === null || slotProps === void 0 ? void 0 : slotProps.container) !== null && _slotProps$container !== void 0 ? _slotProps$container : {},
    containerSlotPropsClassName = _ref.className,
    containerSlotProps = _objectWithoutProperties(_ref, _excluded2);
  var ContentContainer = (_slots$contentContain = slots.contentContainer) !== null && _slots$contentContain !== void 0 ? _slots$contentContain : 'div';
  var _ref2 = (_slotProps$contentCon = slotProps === null || slotProps === void 0 ? void 0 : slotProps.contentContainer) !== null && _slotProps$contentCon !== void 0 ? _slotProps$contentCon : {},
    contentContainerSlotPropsClassName = _ref2.className,
    contentContainerSlotProps = _objectWithoutProperties(_ref2, _excluded3);
  var PreHeading = (_slots$preHeading = slots.preHeading) !== null && _slots$preHeading !== void 0 ? _slots$preHeading : _Typography.Typography;
  var _ref3 = (_slotProps$preHeading = slotProps.preHeading) !== null && _slotProps$preHeading !== void 0 ? _slotProps$preHeading : {},
    preHeadingSlotPropsClassName = _ref3.className,
    preHeadingSlotProps = _objectWithoutProperties(_ref3, _excluded4);
  // If preHeading slot provided then do not spread Typography specific props else combine
  var preHeadingProps = slots.preHeading ? preHeadingSlotProps : _objectSpread({
    variant: 'small-body-semibold'
  }, preHeadingSlotProps);
  var Heading = (_slots$heading = slots.heading) !== null && _slots$heading !== void 0 ? _slots$heading : _Typography.Typography;
  var _ref4 = (_slotProps$heading = slotProps.heading) !== null && _slotProps$heading !== void 0 ? _slotProps$heading : {},
    headingSlotPropsClassName = _ref4.className,
    headingSlotProps = _objectWithoutProperties(_ref4, _excluded5);
  // If heading slot provided then do not spread Typography specific props else combine
  var headingProps = slots.heading ? headingSlotProps : _objectSpread({
    variant: 'h2'
  }, headingSlotProps);
  var Description = (_slots$description = slots.description) !== null && _slots$description !== void 0 ? _slots$description : _Typography.Typography;
  var _ref5 = (_slotProps$descriptio = slotProps.description) !== null && _slotProps$descriptio !== void 0 ? _slotProps$descriptio : {},
    descriptionSlotPropsClassName = _ref5.className,
    descriptionSlotProps = _objectWithoutProperties(_ref5, _excluded6);
  // If description slot provided then do not spread Typography specific props else combine
  var descriptionProps = slots.description ? descriptionSlotProps : _objectSpread({
    variant: 'body'
  }, descriptionSlotProps);
  var ButtonContainer = (_slots$buttonContaine = slots.buttonContainer) !== null && _slots$buttonContaine !== void 0 ? _slots$buttonContaine : 'div';
  var _ref6 = (_slotProps$buttonCont = slotProps.buttonContainer) !== null && _slotProps$buttonCont !== void 0 ? _slotProps$buttonCont : {},
    buttonContainerSlotPropsClassName = _ref6.className,
    buttonContainerSlotProps = _objectWithoutProperties(_ref6, _excluded7);
  var hasButtonPrimary = !!((_ref7 = (_slots$buttonPrimary = slots.buttonPrimary) !== null && _slots$buttonPrimary !== void 0 ? _slots$buttonPrimary : slotProps.buttonPrimary) !== null && _ref7 !== void 0 ? _ref7 : buttonPrimary);
  var hasButtonSecondary = !!((_ref8 = (_slots$buttonSecondar = slots.buttonSecondary) !== null && _slots$buttonSecondar !== void 0 ? _slots$buttonSecondar : slotProps.buttonSecondary) !== null && _ref8 !== void 0 ? _ref8 : buttonSecondary);
  var hasOneButton = hasButtonPrimary || hasButtonSecondary;
  var hasTwoButtons = hasButtonPrimary && hasButtonSecondary;
  var hasButton = hasOneButton;
  var buttonWidthProp = hasTwoButtons ? 'md' : 'lg';
  var ButtonPrimary = (_slots$buttonPrimary2 = slots.buttonPrimary) !== null && _slots$buttonPrimary2 !== void 0 ? _slots$buttonPrimary2 : _Button.Button;
  var _ref9 = (_slotProps$buttonPrim = slotProps.buttonPrimary) !== null && _slotProps$buttonPrim !== void 0 ? _slotProps$buttonPrim : {},
    buttonPrimarySlotPropsClassName = _ref9.className,
    buttonPrimarySlotProps = _objectWithoutProperties(_ref9, _excluded8);
  var buttonPrimaryDefaultProps = {
    color: 'primary',
    variant: 'filled',
    width: buttonWidthProp
  };
  // If buttonPrimary slot provided then do not spread Button specific props else combine
  var buttonPrimaryProps = slots.buttonPrimary ? buttonPrimarySlotProps : _objectSpread(_objectSpread(_objectSpread({}, buttonPrimaryDefaultProps), buttonPrimary), buttonPrimarySlotProps);
  var ButtonSecondary = (_slots$buttonSecondar2 = slots.buttonSecondary) !== null && _slots$buttonSecondar2 !== void 0 ? _slots$buttonSecondar2 : _Button.Button;
  var _ref10 = (_slotProps$buttonSeco = slotProps.buttonSecondary) !== null && _slotProps$buttonSeco !== void 0 ? _slotProps$buttonSeco : {},
    buttonSecondarySlotPropsClassName = _ref10.className,
    buttonSecondarySlotProps = _objectWithoutProperties(_ref10, _excluded9);
  var buttonSecondaryDefaultProps = {
    color: 'primary',
    variant: 'outlined',
    width: buttonWidthProp
  };
  // If buttonSecondary slot provided then do not spread Button specific props else combine
  var buttonSecondaryProps = slots.buttonSecondary ? buttonSecondarySlotProps : _objectSpread(_objectSpread(_objectSpread({}, buttonSecondaryDefaultProps), buttonSecondary), buttonSecondarySlotProps);
  var ButtonPrimaryContainer = (_slots$buttonPrimaryC = slots.buttonPrimaryContainer) !== null && _slots$buttonPrimaryC !== void 0 ? _slots$buttonPrimaryC : _react.Fragment;
  var ButtonSecondaryContainer = (_slots$buttonSecondar3 = slots.buttonSecondaryContainer) !== null && _slots$buttonSecondar3 !== void 0 ? _slots$buttonSecondar3 : _react.Fragment;
  var ImageContainer = (_slots$imageContainer = slots === null || slots === void 0 ? void 0 : slots.imageContainer) !== null && _slots$imageContainer !== void 0 ? _slots$imageContainer : 'div';
  var _ref11 = (_slotProps$imageConta = slotProps.imageContainer) !== null && _slotProps$imageConta !== void 0 ? _slotProps$imageConta : {},
    imageContainerSlotPropsClassName = _ref11.className,
    imageContainerSlotProps = _objectWithoutProperties(_ref11, _excluded10);
  var Image = (_slots$image = slots.image) !== null && _slots$image !== void 0 ? _slots$image : 'img';
  var imagePropClassName = image.className,
    imagePropProps = _objectWithoutProperties(image, _excluded11);
  var _ref12 = (_slotProps$image = slotProps.image) !== null && _slotProps$image !== void 0 ? _slotProps$image : {},
    imageSlotPropsClassName = _ref12.className,
    imageSlotProps = _objectWithoutProperties(_ref12, _excluded12);
  var imageProps = slots.image ? _objectSpread({}, imageSlotProps) : _objectSpread(_objectSpread({}, imagePropProps), imageSlotProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container.Container, _objectSpread(_objectSpread({
    fullWidth: true,
    className: (0, _helpers.cn)(classesRoot({
      backgroundColor: backgroundColor
    }), className)
  }, rest), {}, {
    as: as,
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)(classesContainer({
        reverse: reverse
      }), containerSlotPropsClassName)
    }, containerSlotProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentContainer, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('flex flex-col self-start lg:self-center gap-3 md:gap-5 lg:basis-6/12', contentContainerSlotPropsClassName)
      }, contentContainerSlotProps), {}, {
        children: [(preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps$preHeading2 = slotProps.preHeading) === null || _slotProps$preHeading2 === void 0 ? void 0 : _slotProps$preHeading2.children) && /*#__PURE__*/(0, _jsxRuntime.jsx)(PreHeading, _objectSpread(_objectSpread({
          className: (0, _helpers.cn)('line-clamp-1', preHeadingSlotPropsClassName)
        }, preHeadingProps), {}, {
          children: preHeading
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(Heading, _objectSpread(_objectSpread({
          className: (0, _helpers.cn)('line-clamp-3 md:line-clamp-2', headingSlotPropsClassName)
        }, headingProps), {}, {
          children: heading
        })), (description !== null && description !== void 0 ? description : (_slotProps$descriptio2 = slotProps.description) === null || _slotProps$descriptio2 === void 0 ? void 0 : _slotProps$descriptio2.children) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Description, _objectSpread(_objectSpread({
          className: (0, _helpers.cn)('scl-rich-text', descriptionSlotPropsClassName)
        }, descriptionProps), {}, {
          children: description
        })), hasButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)(ButtonContainer, _objectSpread(_objectSpread({
          className: (0, _helpers.cn)('flex flex-col md:flex-row gap-5 w-full pt-2 empty:hidden', buttonContainerSlotPropsClassName)
        }, buttonContainerSlotProps), {}, {
          children: [hasButtonPrimary && /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonPrimaryContainer, _objectSpread(_objectSpread({}, slotProps.buttonPrimaryContainer), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonPrimary, _objectSpread({}, buttonPrimaryProps))
          })), hasButtonSecondary && /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonSecondaryContainer, _objectSpread(_objectSpread({}, slotProps.buttonSecondaryContainer), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonSecondary, _objectSpread({}, buttonSecondaryProps))
          }))]
        }))]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageContainer, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('lg:basis-6/12', imageContainerSlotPropsClassName)
      }, imageContainerSlotProps), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, _objectSpread({
          className: (0, _helpers.cn)('rounded-xl w-full aspect-video', imagePropClassName, imageSlotPropsClassName)
        }, imageProps))
      }))]
    }))
  }));
});